import { lazyLoad } from "utils/loadable"

export const RiderDashboard = lazyLoad(
  () => import("./index"),
  module => module.RiderDashboard,
)
